import { render, staticRenderFns } from "./InputDateText.vue?vue&type=template&id=571192c5"
import script from "./InputDateText.vue?vue&type=script&lang=js"
export * from "./InputDateText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports